import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { consumeAuthFromLocation } from "../../utils/authToken";
import { isMangoFeatureEnabled } from "../../utils/featureFlags";

const UserTokenHandler = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const mangoFeatureEnabled = isMangoFeatureEnabled();

  useEffect(() => {
    const authReturn = consumeAuthFromLocation(
      location.pathname,
      location.search,
    );
    const Sundarbantoken = authReturn.token;

    if (Sundarbantoken || authReturn.shouldReplace) {
      try {
        const cleanedPath = authReturn.nextSearch
          ? `${authReturn.nextPath}?${authReturn.nextSearch}`
          : authReturn.nextPath;

        // If we have a pricing draft keep flag, route to bookings after login
        const keepDraft =
          Boolean(Sundarbantoken) &&
          localStorage.getItem("sundorbonPricingDraftKeep");
        if (keepDraft) {
          // Check if it's a mango pricing draft
          const draftRaw = localStorage.getItem("sundorbonPricingDraft");
          const isMango = draftRaw
            ? JSON.parse(draftRaw)?.pricingType === "mango"
            : false;
          
          // Navigate to bookings with a query param to indicate mango redirect
          const bookingsPath =
            isMango && mangoFeatureEnabled ? "/?openMangoBooking=1" : "/bookings";
          navigate(bookingsPath, { replace: true });
          
          // Clear the flag after navigation
          localStorage.removeItem("sundorbonPricingDraftKeep");
        } else {
          navigate(cleanedPath, { replace: true });
        }
      } catch (error) {
        console.error("Error decoding token:", error);
      }
    }
  }, [location.search, navigate, location.pathname, mangoFeatureEnabled]);
};

export default UserTokenHandler;
